(() => {
  const checklist = document.querySelector('[data-dd-checklist]');
  if (!checklist) return;

  document.documentElement.classList.remove('no-js');

  const storageKey = 'ddrippy-sale-checklist-v1';
  const checks = [...checklist.querySelectorAll('[data-dd-check]')];
  const phases = [...checklist.querySelectorAll('[data-dd-phase]')];
  const metaFields = [...checklist.querySelectorAll('[data-dd-meta]')];
  const filterButtons = [...checklist.querySelectorAll('[data-dd-filter]')];
  const totalReady = checklist.querySelector('[data-dd-total-ready]');
  const totalCount = checklist.querySelector('[data-dd-total-count]');
  const progressBar = checklist.querySelector('[data-dd-progress-bar]');
  const progressLabel = checklist.querySelector('[data-dd-progress-label]');
  const complete = checklist.querySelector('[data-dd-complete]');
  const empty = checklist.querySelector('[data-dd-empty]');
  let activeFilter = 'all';

  const readState = () => {
    try {
      const state = JSON.parse(localStorage.getItem(storageKey) || '{}');
      return {
        checked: Array.isArray(state.checked) ? state.checked : [],
        meta: state.meta && typeof state.meta === 'object' ? state.meta : {},
      };
    } catch (_error) {
      return { checked: [], meta: {} };
    }
  };

  const saveState = () => {
    const state = {
      checked: checks.filter((input) => input.checked).map((input) => input.id),
      meta: Object.fromEntries(metaFields.map((input) => [input.name, input.value])),
    };

    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (_error) {
      // The checklist still works when storage is blocked by the browser.
    }
  };

  const applyFilter = () => {
    let visibleItems = 0;

    phases.forEach((phase) => {
      const phaseChecks = [...phase.querySelectorAll('[data-dd-check]')];
      let visibleInPhase = 0;

      phaseChecks.forEach((input) => {
        const item = input.closest('.ddr-check-item');
        const visible = activeFilter === 'all'
          || (activeFilter === 'ready' && input.checked)
          || (activeFilter === 'missing' && !input.checked);

        if (item) item.hidden = !visible;
        if (visible) {
          visibleInPhase += 1;
          visibleItems += 1;
        }
      });

      phase.hidden = visibleInPhase === 0;
    });

    if (empty) empty.hidden = visibleItems !== 0;
  };

  const updateProgress = () => {
    const ready = checks.filter((input) => input.checked).length;
    const percentage = checks.length ? Math.round((ready / checks.length) * 100) : 0;

    if (totalReady) totalReady.textContent = String(ready);
    if (totalCount) totalCount.textContent = String(checks.length);
    if (progressBar) progressBar.style.width = `${percentage}%`;
    if (progressLabel) progressLabel.textContent = `${percentage}% complete`;
    if (complete) complete.hidden = ready !== checks.length || checks.length === 0;

    phases.forEach((phase) => {
      const phaseChecks = [...phase.querySelectorAll('[data-dd-check]')];
      const phaseReady = phaseChecks.filter((input) => input.checked).length;
      const readyOutput = phase.querySelector('[data-dd-phase-ready]');
      const countOutput = phase.querySelector('[data-dd-phase-count]');

      if (readyOutput) readyOutput.textContent = String(phaseReady);
      if (countOutput) countOutput.textContent = String(phaseChecks.length);
    });

    applyFilter();
  };

  const setFilter = (filter) => {
    activeFilter = filter;
    filterButtons.forEach((button) => {
      const isActive = button.dataset.ddFilter === filter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
    applyFilter();
  };

  const state = readState();
  const checkedIds = new Set(state.checked);
  checks.forEach((input) => {
    input.checked = checkedIds.has(input.id);
    input.addEventListener('change', () => {
      saveState();
      updateProgress();
    });
  });

  metaFields.forEach((input) => {
    if (typeof state.meta[input.name] === 'string') {
      input.value = state.meta[input.name];
    }
    input.addEventListener('input', saveState);
    input.addEventListener('change', saveState);
  });

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => setFilter(button.dataset.ddFilter));
  });

  checklist.querySelector('[data-dd-print]')?.addEventListener('click', () => window.print());
  checklist.querySelector('[data-dd-reset]')?.addEventListener('click', () => {
    if (!window.confirm('Reset all checklist items and campaign details?')) return;

    checks.forEach((input) => {
      input.checked = false;
    });
    metaFields.forEach((input) => {
      input.value = '';
    });

    try {
      localStorage.removeItem(storageKey);
    } catch (_error) {
      // Nothing else is required when storage is blocked.
    }

    setFilter('all');
    updateProgress();
  });

  updateProgress();
})();
